import { render, staticRenderFns } from "./RelatorioBoletos.vue?vue&type=template&id=523be237&"
import script from "./RelatorioBoletos.vue?vue&type=script&lang=js&"
export * from "./RelatorioBoletos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports